import regularPlans from "./regularPlans";

const regularPlanService = [
    {
        matcher: 'regularPlans',
        reply: config => {
            return [200, regularPlans];
        }
    },
    {
        matcher: /regularPlans\/(.*)/,
        reply: config => {
            const uuid = /regularPlans\/(.*)/.exec(config.url)[1];
            const regularPlan = regularPlans.find(regularPlan => regularPlan.uuid === uuid);
            return [200, regularPlan];
        }
    },
]

export default regularPlanService;